<template>
  <v-dialog
    v-model="modalVisible"
    :scrollable="scrollable"
    :max-width="maxWidth"
    :persistent="shouldPersist"
    :fullscreen="fullscreen"
    no-click-animation
  >
    <v-card :class="cardClass">
      <v-card-title
        v-if="!noTitle"
        class="grey lighten-3"
        :class="[ titlePadding, { 'pa-5': !smallTitle && !titlePadding } ]"
      >
        <v-row
          no-gutters
          align="center"
        >
          <v-col
            :class="{ 'title': !smallTitle, 'subtitle-1': smallTitle }"
          >
            <slot name="dialogTitle" />
          </v-col>
          <v-col
            cols="auto"
            class="px-3"
            :class="{ 'hidden-sm-and-up': !forceCloseIcon }"
          >
            <v-btn
              icon
              text
              class="ma-0"
              @click="modalVisible = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider v-if="!noTitle" />
      <slot />
      <v-divider />
      <v-card-actions
        v-if="$slots.dialogActions"
        class="pa-4 no-gutters"
      >
        <slot name="dialogActions" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ContentDialog',
  props: {
    visible: Boolean,
    maxWidth: {
      type: [String, Number],
      default: '800px'
    },
    smallTitle: {
      type: Boolean,
      default: false
    },
    noTitle: {
      type: Boolean,
      default: false
    },
    scrollable: {
      type: Boolean,
      default: true
    },
    persistent: {
      type: Boolean,
      default: false
    },
    titlePadding: {
      type: String,
      default: undefined
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    cardClass: {
      type: String,
      default: undefined
    },
    forceCloseIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    },
    shouldPersist: function () {
      return this.persistent || this.$store.state.ui.alert.wasActive
    }
  }
}
</script>
